var render = function (_h,_vm) {var _c=_vm._c;return _c('transition',{attrs:{"name":"fadelong","appear":""}},[(_vm.props.msg.length)?_c('div',{staticClass:"bottom-fixed"},[_vm._v(_vm._s(_vm.props.msg))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }